module.exports = __webpack_public_path__ + "img/ne.4c723eaa.svg";